import { Stack, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { ComponentPropsWithoutRef } from "react";
import z from "zod";
import { TabsComponent } from "@/components/core/tabs-component";
import { CustomersTable } from "@/components/tables/customers";
import { InvoicesTable } from "@/components/tables/invoices";

const tabs = ["customers", "invoices"] as const;

const schema = z.object({
  tab: z.enum(tabs).default("customers").catch("customers"),
});

export const Route = createFileRoute("/_authenticated/_contained/customers/")({
  component: RouteComponent,
  validateSearch: schema,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  const tabObjs: (ComponentPropsWithoutRef<typeof TabsComponent>["tabs"][number] & {
    id: (typeof tabs)[number];
  })[] = [
    { id: "customers", label: "Customers", component: <CustomersTable /> },
    { id: "invoices", label: "Invoices", component: <InvoicesTable /> },
  ];

  return (
    <Stack spacing={2}>
      <Typography variant="h3">Customers</Typography>
      <TabsComponent
        tabs={tabObjs}
        selectedTab={tabObjs.findIndex((tabObj) => tabObj.id === tab)}
        onSelectedTab={(idx) => {
          navigate({ search: { tab: tabObjs[idx].id } });
        }}
      />
    </Stack>
  );
}
